interface ErrorPageProps {
  title?: string
  message?: string
}

export function ErrorPage({
  title = 'An error occurred',
  message = "We're sorry, something went wrong.",
}: ErrorPageProps) {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4">
      <div className="mx-auto max-w-md text-center">
        <h1 className="mb-4 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          {title}
        </h1>
        <p className="mb-8 text-lg text-gray-600">{message}</p>
        <div className="flex flex-col space-y-3 sm:flex-row sm:space-x-3 sm:space-y-0"></div>
      </div>
    </div>
  )
}
